/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ExtendedSearchCategorySearchTab_categories$ref = any;
type ExtendedSearchDualSearchTab_event$ref = any;
type ExtendedSearchGpsSearchTab_eventDates$ref = any;
type ExtendedSearchStravaTab_eventDates$ref = any;
type StartNumberSearch_info$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventSearchOptions_eventSearchOptionsInfo$ref: FragmentReference;
declare export opaque type EventSearchOptions_eventSearchOptionsInfo$fragmentType: EventSearchOptions_eventSearchOptionsInfo$ref;
export type EventSearchOptions_eventSearchOptionsInfo = {|
  +id: string,
  +sgId: ?number,
  +mainSearch: ?string,
  +searchDual: ?boolean,
  +gps: ?boolean,
  +searchCollections: ?boolean,
  +$fragmentRefs: ExtendedSearchCategorySearchTab_categories$ref & ExtendedSearchDualSearchTab_event$ref & StartNumberSearch_info$ref & ExtendedSearchGpsSearchTab_eventDates$ref & ExtendedSearchStravaTab_eventDates$ref,
  +$refType: EventSearchOptions_eventSearchOptionsInfo$ref,
|};
export type EventSearchOptions_eventSearchOptionsInfo$data = EventSearchOptions_eventSearchOptionsInfo;
export type EventSearchOptions_eventSearchOptionsInfo$key = {
  +$data?: EventSearchOptions_eventSearchOptionsInfo$data,
  +$fragmentRefs: EventSearchOptions_eventSearchOptionsInfo$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "EventSearchOptions_eventSearchOptionsInfo",
  "type": "Event",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "sgId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "mainSearch",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "searchDual",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "gps",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "searchCollections",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ExtendedSearchCategorySearchTab_categories",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ExtendedSearchDualSearchTab_event",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StartNumberSearch_info",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ExtendedSearchGpsSearchTab_eventDates",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ExtendedSearchStravaTab_eventDates",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ed0fbbf2268b010942244a2b729d9f65';

module.exports = node;
